import headerScroll from '../partials/header'
import threeColumnSliderInit from '../partials/three-column-slider'
import Swiper from 'swiper'
import 'select2'
import 'air-datepicker'

export default {
  init() {
    window.onscroll = headerScroll;
    threeColumnSliderInit();

    //Video Button Actions
    $('.play').on('click', function () {
      $(this).css({'opacity':'0', 'z-index': '-1'});
      $(this).parent().find('.pause').addClass('visible');
      // $(this).parent().find('video').get(0).play();
    });
    $('.pause').on('click', function () {
      $(this).removeClass('visible');
      $(this).parent().find('.play').css({'opacity':'1', 'z-index': '1'});
      // $(this).parent().find('video').get(0).pause();
    });


    if (window.innerWidth < 992) {
      // eslint-disable-next-line
      let vacanciesSlider = new Swiper('.vacancies__slider', {
        spaceBetween: 17,
        width: 290,
        breakpoints: {
          575: {
            spaceBetween: 20,
            width: 343,
          },
        },
      });
    } else {
      // eslint-disable-next-line
      let vacanciesSlider = new Swiper('.vacancies__slider', {
        slidesPerView: 3,
        spaceBetween: 30,
      });
    }

    //Select2
    $('#select2').select2({
      placeholder: 'Select a state',
      width: '100%',
    });

    //Form input Actions
    $('.input__check').on('change', function () {
      if ($(this).val() !== '') {
        $(this).parent().addClass('has-value');
      } else {
        $(this).parent().removeClass('has-value');
      }
    });


    //AirPicker German
    $.fn.datepicker.language['de'] = {
      days: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
      daysShort: ['Son', 'Mon', 'Die', 'Mit', 'Don', 'Fre', 'Sam'],
      daysMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
      months: ['Januar','Februar','März','April','Mai','Juni', 'Juli','August','September','Oktober','November','Dezember'],
      monthsShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
      today: 'Heute',
      clear: 'Aufräumen',
      dateFormat: 'dd.mm.yyyy',
      timeFormat: 'hh:ii',
      firstDay: 1,
    };

    setTimeout(function () {
      let currentColor;
      setInterval(function () {
        currentColor = $('.bg-color-change').css('background-color');
        $('.setCurrentColor--stroke').css('stroke', currentColor);
        $('.-current-').css('background-color', currentColor);
        $('.-selected-').css('background-color', currentColor);
      }, 25);
    }, 300);
    //AirPicker Init
    $('#begin').datepicker({
        language: 'de',
        onSelect: addArrows,
        onChangeMonth: addArrows,
    }
    );
    $('#end').datepicker({
      language: 'de',
      onSelect: addArrows,
      onChangeMonth: addArrows,
    });

    $('.select2-selection__arrow').remove();
    $('.select2-selection').append(' ' +
      '              <label for="end" class="contact-form__dates__label">\n' +
      '                <svg xmlns="http://www.w3.org/2000/svg" width="17.848" height="11.752" viewBox="0 0 17.848 11.752">\n' +
      '                  <g transform="translate(2.828 8.924) rotate(-90)">\n' +
      '                    <path class="stroke-color-change" d="M0,0,6.1,6.1,0,12.191" transform="translate(6.095 12.191) rotate(180)" fill="none" stroke="#e50046" stroke-linecap="round" stroke-miterlimit="10" stroke-width="4"/>\n' +
      '                  </g>\n' +
      '                </svg>\n' +
      '              </label>\n');

    // eslint-disable-next-line
    function addArrows() {
      console.log('Trigger')
      setTimeout(function () {
        $('.datepicker--nav-action[data-action="prev"]').html('<svg xmlns="http://www.w3.org/2000/svg" width="13.752" height="21.848" viewBox="0 0 13.752 21.848"><g transform="translate(2.828 2.828)"><path class="setCurrentColor--stroke" d="M0,0,8.1,8.1,0,16.191" transform="translate(8.095 16.191) rotate(180)" fill="none" stroke="#e50046" stroke-linecap="round" stroke-miterlimit="10" stroke-width="4"/></g></svg>');
        $('.datepicker--nav-action[data-action="next"]').html('<svg xmlns="http://www.w3.org/2000/svg" width="13.752" height="21.848" viewBox="0 0 13.752 21.848"><g transform="translate(10.924 19.019) rotate(180)"><path class="setCurrentColor--stroke" d="M0,0,8.1,8.1,0,16.191" transform="translate(8.095 16.191) rotate(180)" fill="none" stroke="#e50046" stroke-linecap="round" stroke-miterlimit="10" stroke-width="4"/></g></svg>');
      }, 10);
    }
    addArrows();
  },

  // JavaScript to be fired on all pages, after page specific JS is fired
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/trainingPage.js